import url from './url'
const AppConsts= {
    userManagement:{
        defaultAdminUserName: 'admin'
    },
    localization:{
        defaultLocalizationSourceName: 'PostVenta'
    },
    authorization:{
        encrptedAuthTokenName: 'enc_auth_token'
    },
    setting: {
        shrink: false,
        confirmLeave: false,
        nroTabs: 9,
        timeout: 1800000,
        appName: 'PostVenta',
    },
    appBaseUrl: "http://localhost:8080",
    remoteServiceBaseUrl: url

}
export default AppConsts